import './App.css';
import { useDispatch } from 'react-redux';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import HomePage from './components/HomePage/HomePage';
import CategoryPage from './components/CategoryPage/CategoryPage';
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import MessagesPage from './components/Messages/MessagesComponent';
import SearchScreen from './components/SearchScreen/searchScreen';
import RentalForm from './Utils/CreatePosts/RentalForm/createRental';
import OtherListingForm from './Utils/CreatePosts/OthersListing/OtherListing';
import CommerceListing from './Utils/CreatePosts/CommerceForm/CommerceListing';
import ProfilePage from './Utils/ProfilePage/ProfilePage';
import { ToastContainer } from 'react-toastify';
// import AuthLayout from './Utils/UnAuthPages/AuthLayout';
import LoginPage from './Utils/UnAuthPages/Login/LoginPage';
import SignupPage from './Utils/UnAuthPages/SignUpPage/SignUpPage';
import MainLandingPage from './components/LandingPage/LandingPage';
import AboutPage from './Utils/UnAuthPages/AboutPage/AboutPage';
import ServicesPage from './Utils/UnAuthPages/Services/ServicesPage';
import FAQPage from './Utils/UnAuthPages/FAQPage/FAQPage';
import ContactPage from './Utils/UnAuthPages/ContactPage/ContactPage';
import ScrollToTop from "./scrollToTop/ScrollToTop";
import ProtectedRoute from "./ProtectedRoute";
import RequireCorporateVerified from "./components/RequireCorporateVerified";
import { useEffect,useState, useCallback } from 'react';
import { setUserDetails, setUserId, setUserName } from './redux/userSlice';
import Loader from './Utils/UnAuthPages/Loader/Loader';
//import AnnouncementBar from './components/Anouncement/AnnouncementBar';
import ForgotPassword from './components/ForgotPassword/ForgotPassword';
import ResourceLoader from './Utils/UnAuthPages/resourceLoader/ResourceLoader';
import { apiUrl, jsonAuthHeaders } from './config/api.js';
import { devLog, devWarn } from './config/devLog.js';
import { isAccessTokenValid, clearClientSession } from './authTokenUtils.js';


function App() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation();
  const [loading, setLoading] = useState(true)
  const [resourceLoading, setResourceLoading] = useState(true)
  const [messagesReceived,setMessagesReceived]=useState([])
  // Removed empty destructuring pattern


    const getInterests = useCallback(async () => {
      try {
        // setLoading(true);
        setResourceLoading(true);
        const userId =
          localStorage.getItem("userID") || localStorage.getItem("userId");
        if (
          userId == null ||
          userId === "" ||
          userId === "null" ||
          userId === "undefined"
        ) {
          setResourceLoading(false);
          setLoading(false);
          return;
        }
        const res = await fetch(apiUrl("getInterests?" + userId), {
          headers: jsonAuthHeaders(),
        });
        const responses = await res.json();
        devLog("[app] getInterests", { count: Array.isArray(responses) ? responses.length : 0 });
        
        let received = [];

        if (!responses.message && responses.length > 0) {
          responses.forEach((interest) => {
            if (String(interest.host_id) === String(userId)) {
              devLog("[app] interest for host", { id: interest.id, seen: interest.seen });
            }
            if (String(interest.host_id) === String(userId) && !interest.seen) {
              received.push({
                id: interest.id,
                type: "received",
                listingId: interest.listing_id,
                senderId: interest.sender_id,
                hostId: interest.host_id,
                name: interest.first_name + " " + interest.last_name,
                contact: interest.mobile_number,
                email: interest.email,
                postTitle: interest.listing_title || interest.listing_category + " items for Sale",
                postImage: interest.image_url?.split(",")[0] || "",
                message: interest.message,
                createdAt: interest.created_at,
                seen: interest.seen
              });
            }
          });
         
          setMessagesReceived([...received]);
        }
      } catch (error) {
        devLog("[app] getInterests error", error?.message);
      } finally {
        setLoading(false);
        setResourceLoading(false);
      }
    }, []);
  
    useEffect(() => {
      getInterests();
    }, [location.pathname, getInterests]);

  const getUserDetails = useCallback(async () => {
    try {
      const storedId = localStorage.getItem("userID") || localStorage.getItem("userId");
      if (!storedId) return;

      let userDetails = null;

      // Try GET /getUser?{id} first (LoginPage uses this endpoint)
      try {
        const profileRes = await fetch(apiUrl("getUser?" + storedId));
        if (profileRes.ok) {
          const profileData = await profileRes.json();
          userDetails = {
            ...profileData,
            userId: profileData.id || storedId,
            name: profileData.name || (profileData.first_name ? profileData.first_name + " " + profileData.last_name : "")
          };
        }
      } catch (err) {
        devWarn("[app] getUser fetch failed, falling back to getUserDetails", err?.message);
      }

      // Fallback to POST /getUserDetails if needed
      if (!userDetails) {
        const response = await fetch(apiUrl("getUserDetails"), {
          method: "POST",
          headers: jsonAuthHeaders(),
          body: JSON.stringify({ userId: storedId })
        });
        const userData = await response.json();
        if (userData && userData.success) {
          userDetails = userData.userDetails;
        }
      }

      if (userDetails) {
        dispatch(setUserDetails(userDetails));
        dispatch(setUserId(userDetails.userId || storedId));
        dispatch(setUserName(userDetails.name || (userDetails.first_name ? userDetails.first_name + " " + userDetails.last_name : "")));
        // Keep both keys in sync for compatibility
        localStorage.setItem('userID', storedId);
        localStorage.setItem('userId', storedId);
      }
    } catch (error) {
      devLog("Error fetching user details:", error?.message);
    }
  }, [dispatch]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);

    const token = localStorage.getItem("token");
    if (token && !isAccessTokenValid(token)) {
      clearClientSession();
    }

    // If user is already logged in (token or stored user id), navigate to home
    const storedId = localStorage.getItem("userID") || localStorage.getItem("userId");
    const tokenAfter = localStorage.getItem("token");
    if (storedId || tokenAfter) {
      getUserDetails();
      // If current path is a public route, redirect to /home
      const publicPaths = ["/login", "/signup", "/", "/about", "/services", "/contact", "/faq", "/forgotpassword"];
      const currentPath = window.location.pathname.toLowerCase();
      if (publicPaths.includes(currentPath) || currentPath === "/") {
        navigate('/home');
      }
    }

    return () => clearTimeout(timer);
  }, [getUserDetails, navigate]);

  return (
    <div className="App">
      <ScrollToTop />
      {loading ? <Loader /> : (
          <>
           <Header></Header>
             <ToastContainer position="bottom-center" />
             {resourceLoading && <ResourceLoader />}
            <div className={["/signup","/login","/","/about","/services","/contact","/faq","/forgotpassword"].includes(window.location.pathname.toLowerCase())?"nonAuthContainer":'homeContainer'}>
            <Routes>
              {/* Non-authenticated routes */}
              <Route path="/login" element={<LoginPage />} />
              <Route path="/forgotPassword" element={<ForgotPassword />} />
              <Route path="/signUp" element={<SignupPage />} />
              <Route path="/" element={<MainLandingPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/faq" element={<FAQPage />} />
              <Route path="/contact" element={<ContactPage />} />
              
              {/* Authenticated routes with sidebar */}
              <Route path="/home" element={
                <div className="app-container">
                  <div className="sidebar">
                    {/* Dashboard Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                        Dashboard
                      </button>
                    </div>

                    {/* Account Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    {/* View Posts Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
                      </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div className="app-main-content">
                    <ProtectedRoute><HomePage /></ProtectedRoute>
                  </div>
                </div>
              } />
              
              <Route path="/featured" element={
                <div className="app-container">
                  <div className="sidebar">
                    {/* Dashboard Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                        Dashboard
                      </button>
                    </div>

                    {/* Account Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    {/* View Posts Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
                      </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div className="app-main-content">
                    <ProtectedRoute><CategoryPage /></ProtectedRoute>
                  </div>
                </div>
              } />
              
              <Route path="/latest" element={
                <div className="app-container">
                  <div className="sidebar">
                    {/* Dashboard Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                Dashboard
                      </button>
                    </div>

                    {/* Account Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    {/* View Posts Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
                      </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                      </div>
                    </div>
            </div>

                  <div className="app-main-content">
                    <ProtectedRoute><CategoryPage /></ProtectedRoute>
                  </div>
                </div>
              } />
              
              <Route path="/my-posts" element={
                <div className="app-container">
                  <div className="sidebar">
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                        Dashboard
                      </button>
                    </div>

                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
                      </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div className="app-main-content">
                    <ProtectedRoute><CategoryPage /></ProtectedRoute>
                  </div>
                </div>
              } />
              
              <Route path="/trending" element={
                <div className="app-container">
                  <div className="sidebar">
                    {/* Dashboard Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                        Dashboard
                      </button>
                    </div>

                    {/* Account Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    {/* View Posts Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
                      </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                      </div>
                    </div>
          </div>
                  
                  <div className="app-main-content">
                    <ProtectedRoute><CategoryPage /></ProtectedRoute>
                  </div>
                </div>
              } />
              
              <Route path="/today" element={
                <div className="app-container">
                  <div className="sidebar">
                    {/* Dashboard Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                        Dashboard
                      </button>
                    </div>

                    {/* Account Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    {/* View Posts Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
                      </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                      </div>
                    </div>
            </div>

                  <div className="app-main-content">
                    <ProtectedRoute><CategoryPage /></ProtectedRoute>
                  </div>
                </div>
              } />
              
              <Route path="/messages" element={
                <div className="app-container">
                  <div className="sidebar">
                    {/* Dashboard Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                        Dashboard
                      </button>
                    </div>

                    {/* Account Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
          </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    {/* View Posts Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
                      </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div className="app-main-content">
                    <ProtectedRoute><MessagesPage /></ProtectedRoute>
                  </div>
                </div>
              } />
              
              <Route path="/received" element={
                <div className="app-container">
                  <div className="sidebar">
                    {/* Dashboard Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                        Dashboard
                      </button>
                    </div>

                    {/* Account Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    {/* View Posts Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
                      </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                      </div>
                    </div>
            </div>

                  <div className="app-main-content">
                    <ProtectedRoute><MessagesPage /></ProtectedRoute>
                  </div>
                </div>
              } />
              
              <Route path="/createRental" element={
                <div className="app-container">
                  <div className="sidebar">
                    {/* Dashboard Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                        Dashboard
                      </button>
                    </div>

                    {/* Account Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    {/* View Posts Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
          </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div className="app-main-content">
                    <ProtectedRoute><RequireCorporateVerified><RentalForm /></RequireCorporateVerified></ProtectedRoute>
                  </div>
                </div>
              } />
              
              <Route path="/createOtherListing" element={
                <div className="app-container">
                  <div className="sidebar">
                    {/* Dashboard Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                        Dashboard
                      </button>
                    </div>

                    {/* Account Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    {/* View Posts Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
                      </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                    </div>
                    </div>
                  </div>
                  
                  <div className="app-main-content">
                    <ProtectedRoute><RequireCorporateVerified><OtherListingForm /></RequireCorporateVerified></ProtectedRoute>
                  </div>
                </div>
              } />
              
              <Route path="/createCommerceListing" element={
                <div className="app-container">
                  <div className="sidebar">
                    {/* Dashboard Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                        Dashboard
                      </button>
                    </div>

                    {/* Account Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    {/* View Posts Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
                      </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div className="app-main-content">
                    <ProtectedRoute><RequireCorporateVerified><CommerceListing /></RequireCorporateVerified></ProtectedRoute>
                  </div>
                </div>
              } />
              
              <Route path="/profile" element={
                <div className="app-container">
                  <div className="sidebar">
                    {/* Dashboard Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                        Dashboard
                      </button>
                    </div>

                    {/* Account Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    {/* View Posts Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
                      </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div className="app-main-content">
                    <ProtectedRoute><ProfilePage /></ProtectedRoute>
                  </div>
                </div>
              } />
              
              <Route path="/search" element={
                <div className="app-container">
                  <div className="sidebar">
                    {/* Dashboard Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Dashboard</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/home" ? "active" : ""}`}
                        onClick={() => navigate("/home")}
                      >
                        Dashboard
                      </button>
                    </div>

                    {/* Account Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>Account</h4>
                      </div>
                      <button 
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/profile" ? "active" : ""}`}
                        onClick={() => navigate("/profile")}
                      >
                        Profile
                      </button>
                      <button
                        className={`messages-nav-item ${window.location.pathname.toLowerCase() === "/messages" ? "active" : ""}`}
                        onClick={() => navigate("/messages")}
                      >
                        <span>Messages</span>
                        <span className="messages-badge">{messagesReceived.length}</span>
                      </button>
                      <button
                        type="button"
                        className={`sidebar-nav-item ${window.location.pathname.toLowerCase() === "/my-posts" ? "active" : ""}`}
                        onClick={() => navigate("/my-posts")}
                      >
                        My posts
                      </button>
                    </div>

                    {/* View Posts Section */}
                    <div className="sidebar-section">
                      <div className="sidebar-section-title">
                        <h4>View Posts</h4>
                      </div>
                      <div className="post-tags-container">
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/today" ? "active" : ""}`}
                          onClick={() => navigate("/today")}
                        >
                          Today's Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/trending" ? "active" : ""}`}
                          onClick={() => navigate("/trending")}
                        >
                          Top Posts
                        </button>
                        <button 
                          className={`post-tag ${window.location.pathname.toLowerCase() === "/latest" ? "active" : ""}`}
                          onClick={() => navigate("/latest")}
                        >
                          Latest Posts
                        </button>
                      </div>
                    </div>
                  </div>
                  
                  <div className="app-main-content">
                    <ProtectedRoute><SearchScreen /></ProtectedRoute>
                  </div>
                </div>
              } />
              </Routes>
            </div>
            <Footer></Footer>
        </>
      )}
     </div>
  );
}

export default App;